<template>
  <el-aside
    :style="{ width: menuIsCollapse ? '64px' : '200px' }"
    class="asideNav sider"
  >
    <nav>
      <div
        class="logo"
        :style="{ 'margin-right': menuIsCollapse ? '22px' : '15px' }"
      >
        <!-- <icon-svg iconClass="expend" @click.native="changeCollapse"></icon-svg> -->
        <!-- <icon-svg iconClass="expend"></icon-svg> -->
        <div class="el-icon-sort inside" @click="changeCollapse"></div>
      </div>
      <el-menu
        class="el-menu-vertical-demo sider"
        :style="{ width: menuIsCollapse ? '64px' : '200px' }"
        :collapse="menuIsCollapse"
        default-active="1"
        :unique-opened="false"
        @open="handleOpen"
        @close="handleClose"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>集装箱无纸化平台</span>
          </template>
          <el-menu-item-group v-if="power('TK_USER_ADMIN') && isShowDdyb =='gy,ct'">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/monitorPlatform',
                  name: '港区监控平台',
                })
              "
              index="2-1"
            >
              港区监控平台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_ADMIN')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/businessPlatform',
                  name: '业务监控平台',
                })
              "
              index="2-2"
            >
              业务监控平台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_ADMIN')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/SystemS',
                  name: '系统管理工作台',
                })
              "
              index="2-3"
            >
              系统管理工作台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_SYSTEM')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/basePlatform',
                  name: '基础管理工作台',
                })
              "
              index="2-4"
            >
              基础管理工作台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_SHIP')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/shipCompany',
                  name: '放箱工作台',
                })
              "
              index="2-5"
            >
              放箱工作台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_RAILWAY') && isShowDdyb =='yb'">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/railwayBoxConsignment/index',
                  name: '铁路箱托运',
                })
              "
              index="2-10"
            >
              铁路箱托运
            </el-menu-item>
          </el-menu-item-group>
          <!-- v-if="power('TK_TRUCK_')" -->
          <el-menu-item-group v-if="power('TK_USER_TRUCK')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/trailerCompany',
                  name: '任务处理工作台',
                })
              "
              index="2-6"
            >
              任务处理工作台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="accountType == 'PORT'">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/cargoStation',
                  name: '货站工作平台',
                })
              "
              index="2-7"
            >
              货站工作平台
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_ADMIN')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/quotaList',
                  name: '指标数据查询',
                })
              "
              index="2-8"
            >
              指标数据查询
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_USER_ADMIN')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/carOrderList',
                  name: '集卡预约查询',
                })
              "
              index="2-9"
            >
              集卡预约查询
            </el-menu-item>
          </el-menu-item-group>
<!--          <el-menu-item-group v-if="isClient">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/outCard/emptyContainer/emptyChooseBox',
                  name: '预约堆场选空箱',
                })
              "
              index="2-12"
            >
              预约选空箱
            </el-menu-item>
          </el-menu-item-group> -->
          <el-menu-item-group v-if="power('TK_W2SHIP_SHIP')">
            <el-menu-item
              @click="
                handleRouterPush({
                  path: '/shipsWork/index',
                  name: '船舶工作台',
                })
              "
              index="2-11"
            >
              船舶工作
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="power('TK_W2SHIP_SHIP')">
            <el-menu-item
              @click="jumpToContainerNetworkSystem()"
              index="2-12"
            >
            集装箱外网查询系统
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </nav>
    <view>
      <!-- <div style="margin:0 0 30px 0;">
                <el-row>
                    <el-col :span="12">
                        <span>username:{{loginForm.username}}</span>
                        <span>password:{{loginForm.password}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="2">
                        <el-button type="primary"
                                   @click="pageLogin()"
                                   size="mini"
                                   style="margin:20px 0 0 10px">登录</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary"
                                   @click="loginOut()"
                                   size="mini"
                                   style="margin:20px 0 0 10px">登出</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary"
                                   @click="checkToken()"
                                   size="mini"
                                   style="margin:20px 0 0 10px">检查token</el-button>
                    </el-col>
                    <el-col :span="2">
                        <span>token:{{token}}</span>
                    </el-col>
                </el-row>
            </div> -->
    </view>
  </el-aside>
</template>

<script>
import {  isEmpty } from "@/utils/common";
import { getSystemParameterList } from "@/api/system/systemParameter";
export default {
  name: "navItem",
  data() {
    return {
      accountType: this.$store.state.user.currentUser.accountType,

      itemInfor: {
        item0: {},
      },
      token: "",
      dataLength: 0,
      currentUser:{},
      isClient:false,
      isShowDdyb: this.$isShowDdyb,
    };
  },
  computed: {
    menuIsCollapse() {
      return this.$store.getters.menuIsCollapse;
    },
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    this.currentUser = JSON.parse(localStorage.getItem("currentUserObj"));
    if(!isEmpty(this.currentUser.org.remark) && this.isShowDdyb == "yb"){
       this.isClient = true;       
    }
    console.log("this.currentUser",this.currentUser);
    console.log("导航 this.isShowDdyb",this.isShowDdyb);
    console.log("isClient",this.isClient);


    if (this.$store.state.user.currentUser.accountType) {
      sessionStorage.setItem(
        "accountType",
        this.$store.state.user.currentUser.accountType
      );
    } else {
      this.$nextTick(() => {
        this.accountType = sessionStorage.getItem("accountType");
      });
    }

    // console.log("navltem, this.accountType",this.accountType);
    // this.accountType = "CONTROL";
    // sessionStorage.setItem("accountType","CONTROL");
  },
  mounted() {
    // console.log("无纸化二期  this.accountType", this.accountType);
    // console.log("导航 currentUser",this.$store.state.user.currentUser);
    //加载并登录 无纸化二期
  },
  methods: {
    async jumpToContainerNetworkSystem(){
          let res = await getSystemParameterList({ 'search_LIKE_paramCode': 'CONTAINER_NETWORK_SYSTEM' })
          if(res){
            console.log("跳转链接 getSystemParameterList res",res)
            let jumpUrl = res.data.aaData[0].paramValue
            if(jumpUrl){
               console.log("jumpUrl",jumpUrl)
               window.open(jumpUrl, '_blank');
            }
          }
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleRouterPush(val) {
      // console.log(val)
      this.$store.commit("ADD_CACHED_VIEWS", val);
      this.$router.push(val.path);
      console.log("navltem, handleRouterPush", val.path);
    },
    changeCollapse() {
      this.$store.commit("SET_MENU_COLLAPSE", !this.menuIsCollapse);
    },
  },
};
</script>

<style scoped>
.asideNav {
  height: 100%;
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: rgb(84, 92, 100);
  z-index: 200;
}

.asideNav::-webkit-scrollbar {
  display: none;
}

.logo {
  color: #fff;
  text-align: right;
  margin-right: 15px;
}

.inside {
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}

.sider {
  border: none;
  transition: width 0.28s ease-out;
}

.el-submenu__title .railway-title-span {
  width: 120px;
  height: 55px;
  line-height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/navItem.vue